import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/customer/` + url, ...arg)

/**
 * 客户记录Api接口管理器
 *
 * @author gim
 * @date  2025/06/05 20:58
 **/
export default {
	// 提交客户记录表单 edit为true时为编辑，默认为新增
	tradeCustomerRecordSubmitForm(data, edit = false) {
		return request(edit ? 'edit' : 'add', data)
	},
}
